import { Injectable, signal } from '@angular/core';
import { SupportedRegion } from '@app/areas/auth/models/supported-region.interface';
import { IdentityUserRegion } from '@app/areas/users/models/identity-user.interface';
import {hasValue} from "@shared/utils/helpers";

const REGION_STORAGE_KEY = 'selectedRegion';

@Injectable({ providedIn: 'root' })
export class RegionService {
  private readonly _supportedRegions: SupportedRegion[] = [
    { id: 'australia-southeast1', displayName: 'Australia' },
    { id: 'europe-west2',          displayName: 'United Kingdom' },
    { id: 'northamerica-northeast2', displayName: 'Canada' },
    { id: 'europe-west1',          displayName: 'EU' },
  ];

  selectedRegion$ = signal<IdentityUserRegion | null>(this.loadFromStorage());

  get supportedRegions(): SupportedRegion[] {
    return this._supportedRegions;
  }

  // regions changes are suggested in the app if the user is browsing content in the wrong region
  suggestedRegion$ = signal<SupportedRegion | null>(null)

  /** Returns the currently selected region */
  get(): IdentityUserRegion | null {
    return this.selectedRegion$();
  }

  suggestRegion(region: IdentityUserRegion | null): void {
    if (region === null) {
      this.suggestedRegion$.set(null)
      return;
    }

    const r = this._supportedRegions.find(e => e.id === region)

    if (hasValue(r) && r.id !== this.selectedRegion$()) {
      this.suggestedRegion$.set(r)
    }
  }

  /** Select and persist the region */
  selectRegion(newRegion: IdentityUserRegion | null): void {
    console.log('selectRegion', newRegion)
    this.selectedRegion$.set(newRegion);
    if (newRegion) {
      localStorage.setItem(REGION_STORAGE_KEY, newRegion);
    } else {
      localStorage.removeItem(REGION_STORAGE_KEY);
    }
  }

  /** Reset selection and clear storage */
  reset(): void {
    this.selectedRegion$.set(null);
    localStorage.removeItem(REGION_STORAGE_KEY);
  }

  /** Load previously saved region from localStorage (if exists) */
  private loadFromStorage(): IdentityUserRegion | null {
    const raw = localStorage.getItem(REGION_STORAGE_KEY);
    return (raw as IdentityUserRegion) ?? null;
  }
}
